export const toolReadme = [
  "The Center Settings tool allows you to modify the textable or callable state of each center."
];

export const editingCenterReadme = [
  "Is Active determines whether the Center is selectable by the PAs.",
  "Outbound Call Count determines the number of times an Opportunity will be contacted with automated outbound calls. A setting of 0 will disable outbounds.",
  "Is Textable determines whether automated outbound SMS will be sent for this Center.",
  "Dial Times determine when we will queue calls for the Center. If there are NO Dial Times outbound calls will be disabled."
];

export const dialTimesReadme = [
  "Each Dial Time sets a local time in the Center Time Zone after which we will begin releasing outbound calls. Calls will alternate between these times.",
  "Example: Given Dial Times of 9:15 AM, 1:15 PM, and 7:00 PM, calls will be made in ascending order starting with the time closest to the initial contact time.  For example if the Opportunity was created at Noon the first call would be 1:15PM, then 7:00 PM, then 9:15 AM.",
  "You may disable a Dial Time without deleting it using the Enabled Switch.",
  "You may also delete a Dial Time. Deleted dial times are not recoverable, and must be re-created.",
  "NOTE: When using the Time picker you must select both Hours AND Minutes, or the time will revert to the original value."
];
